import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilitiesService {
  constructor() { }

  setLocalStorageArray(key: string, obj: any): any {
    var string = JSON.stringify(obj);
    var encrypted = btoa(string);
    return sessionStorage.setItem(key, encrypted);
  }

  GetLocalStorageArray(key: string): any {
    var string = sessionStorage.getItem(key);
    var decrypted = atob(string);
    return JSON.parse(decrypted);
  }

  GetLabelCaption(data: any, module: string): any {
    let labelCaption: any = null;
    if (data !== null) {
      labelCaption = data;
      this.setLocalStorageArray(module, data);
    } else {
      labelCaption = this.GetLocalStorageArray(module);
    }
    return labelCaption;
  }

  public static RemoveSessionItems() {
    // to remove the stoed session values
    this.clearSessionItem("isDetailsOfClaimantValid");
    this.clearSessionItem("isDetailsOfAuthorValid");
    this.clearSessionItem("isDetailsOfCreditorValid");
    this.clearSessionItem("isEditScreenActive");
  }

  private static clearSessionItem(key:string) {
    if(sessionStorage.getItem(key) != null) {
      sessionStorage.removeItem(key)
    }
  }

  public static SetIsEditScreenActiveToTrue() {
    // to prevent navigation while present in edit screen
    if(sessionStorage.getItem("isEditScreenActive") != "true") {
      sessionStorage.setItem("isEditScreenActive", "true");
    }
  }
}
export class CompanyItem {
  windingUpNumber: string;
  displayName: string;
  formId: string;
}
